import React from "react";
import Media from "@/components/MediaCoverage";
import FreeAppraisal from "@/components/Common/FreeAppraisal";
import { createClient } from "../../../prismicio";
import Metadata from "@/components/Metadata";
import Layout from "@/components/Layout";

const MediaCoverage = ({ page, pageAll, globals }) => {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  let blog = [];

  {
    pageAll?.map(({ data, uid, last_publication_date }, idx) => {
      var date = new Date(last_publication_date);
      var dateFormat =
        date.getDay() +
        " " +
        date.toLocaleString("default", { month: "long" }) +
        " " +
        date.getFullYear();

      blog.push({
        image: data?.image,
        title: data?.title,
        categoryTitle: data?.category,
        date: dateFormat,
        text: data?.excerpt,
        buttonLink: uid,
      });
    });
  }

  return (
    <Layout data={commonComponents}>
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path="/media-coverage"
      />
      <Media
        title={pageData?.hero_title || ""}
        caption={pageData?.hero_caption || ""}
        description={pageData?.hero_description || ""}
        blogs={blog}
      />
      <FreeAppraisal page={"Media Coverage"} />
      <div style={{ height: "40px" }}></div>
    </Layout>
  );
};

export default MediaCoverage;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("media_coverage_page");
  const pageAll = await client.getAllByType("media_coverage_individual_page");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      pageAll,
      globals,
    },
  };
}
